export default "__VITE_ASSET__BnneQCza__"